module.exports = __webpack_public_path__ + "img/Logo_corner_bottom_right.97f77dcd.jpg";